module.exports = __webpack_public_path__ + "static/media/check-img.cdaa8867.svg";